module.exports = __webpack_public_path__ + "img/this_or_that_robot_tranparent.de25b8c0.gif";